<template>
    <div>
        <div id="n3-change-component" v-if="entity.created_at">
            <div class="n2-order-panel">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <h5>{{ $t('pages.change.contact_information') }}</h5>
                    <div v-if="changeable">
                        <button class="n2-button-1" v-on:click="contact_edit_visible = !contact_edit_visible">{{
                            $t('pages.change.edit')
                            }}</button>
                    </div>
                </div>
                <h6>{{ $t('pages.change.contact_information_desc') }}</h6>
                <table>
                    <tr>
                        <td class="contact-title-field">
                            {{ $t('pages.change.given_name') }}
                        </td>
                        <td class="contact-value-field">
                            <div v-if="contact_edit_visible">
                                <input type="text" v-model="entity.contact.given_name" class="n2-input-default" />
                                <field-error v-bind:errors="contact_errors.given_name"></field-error>
                            </div>
                            <div v-else>
                                {{ entity.contact.given_name }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="contact-title-field">
                            {{ $t('pages.change.family_name') }}
                        </td>
                        <td class="contact-value-field">
                            <div v-if="contact_edit_visible">
                                <input type="text" v-model="entity.contact.family_name" class="n2-input-default" />
                                <field-error v-bind:errors="contact_errors.family_name"></field-error>
                            </div>
                            <div v-else>
                                {{ entity.contact.family_name }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="contact-title-field">
                            {{ $t('pages.change.email') }}
                        </td>
                        <td class="contact-value-field">
                            <div v-if="contact_edit_visible">
                                <input type="text" v-model="entity.contact.email" class="n2-input-default" />
                                <field-error v-bind:errors="contact_errors.email"></field-error>
                            </div>
                            <div v-else>
                                {{ entity.contact.email }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="contact-title-field">
                            {{ $t('pages.change.phone_number') }}
                        </td>
                        <td class="contact-value-field">
                            <div v-if="contact_edit_visible">

                                <phone-number-field v-model="entity.contact.phone_number"
                                    :defaultCountry="entity.contact.address.country_code || 'NO'" :locale="app_locale"
                                    :errors="{ national: contact_errors.phone_number }" />
                            </div>
                            <div v-else>
                                {{ entity.contact.phone_number }}
                            </div>
                        </td>
                    </tr>
                    <template v-if="entity.template != 'online_payment'">
                        <tr>
                            <td class="contact-title-field">
                                {{ $t('pages.change.address_line_1') }}
                            </td>
                            <td class="contact-value-field">
                                <div v-if="contact_edit_visible">
                                    <input type="text" v-model="entity.contact.address.address_line_1"
                                        class="n2-input-default" />
                                    <field-error v-bind:errors="contact_errors.address_line_1"></field-error>
                                </div>
                                <div v-else>
                                    {{ entity.contact.address.address_line_1 }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="contact-title-field">
                                {{ $t('pages.change.locality') }}
                            </td>
                            <td class="contact-value-field">
                                <div v-if="contact_edit_visible">
                                    <input type="text" v-model="entity.contact.address.locality"
                                        class="n2-input-default" />
                                    <field-error v-bind:errors="contact_errors.locality"></field-error>
                                </div>
                                <div v-else>
                                    {{ entity.contact.address.locality }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="contact-title-field">
                                {{ $t('pages.change.postal_code') }}
                            </td>
                            <td class="contact-value-field">
                                <div v-if="contact_edit_visible">
                                    <input type="text" v-model="entity.contact.address.postal_code"
                                        class="n2-input-default" />
                                    <field-error v-bind:errors="contact_errors.postal_code"></field-error>
                                </div>
                                <div v-else>
                                    {{ entity.contact.address.postal_code }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="contact-title-field">
                                {{ $t('pages.change.country_code') }}
                            </td>
                            <td class="contact-value-field">
                                <div v-if="contact_edit_visible">
                                    <app-autocomplete v-model="entity.contact.address.country_code"
                                        v-bind:items="countries" v-bind:text_field="'name'" v-bind:separator="' '"
                                        v-bind:value_field="'code'">
                                    </app-autocomplete>
                                    <field-error v-bind:errors="contact_errors.country_code"></field-error>
                                </div>
                                <div v-else>
                                    {{ getCountryName(entity.contact.address.country_code) }}
                                </div>
                            </td>
                        </tr>
                    </template>
                </table>
                <div v-if="contact_edit_visible">
                    <form-input type="checkbox" v-model="agree_contact_term"
                        v-bind:errors="contact_errors.agree_contact_term">
                        <template v-slot:inline>
                            {{ $t('pages.change.read_term') }}
                            {{ $t('pages.change.term_change') }}
                        </template>
                    </form-input>
                    <div class="n2-padding">
                        <validation-summary v-bind:errors="contact_errors"></validation-summary>
                    </div>
                    <p v-if="error_change_contact_time_passed" style="color: #ff0000;">
                        {{ $t('pages.change.error_change_time_passed') }}
                    </p>
                    <button style="margin: 20px 0 0 0;" v-on:click="updateContact" class="n2-button-1">{{
                        $t('pages.change.update') }}</button>
                </div>

            </div>

            <div v-if="entity.vehicles && entity.vehicles.length > 0" style="margin: 20px 0;" class="n2-order-panel">
                <div>
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <h5>{{ $t('pages.change.vehicles') }}</h5>
                        <div v-if="changeable">
                            <button class="n2-button-1" v-on:click="vehicle_edit_visible = !vehicle_edit_visible">{{
                                $t('pages.change.edit')
                                }}</button>
                        </div>
                    </div>
                    <h6>{{ $t('pages.change.vehicles_desc') }}</h6>
                    <div v-for="(v, index) in entity.vehicles" v-bind:key="v"
                        style="border: 1px solid #cccccc; padding: 10px; margin-top: 10px;">
                        <div>
                            <div class="n2-form-group">
                                <label class="n2-form-label">{{ $t('pages.checkout.vehicle') }} {{ index + 1 }}:
                                    {{ getProductName(v.product_id) }}</label>
                            </div>
                        </div>
                        <div>
                            <div style="width: 360px;">
                                <div v-if="vehicle_edit_visible">
                                    <form-input type="text" v-model="v.model"
                                        v-bind:placeholder="$t('pages.checkout.required_field')"
                                        v-bind:label="$t('pages.checkout.make_and_model')"
                                        v-bind:errors="v.model_errors"></form-input>
                                </div>
                                <div v-else>
                                    {{ $t('pages.checkout.make_and_model') }}:
                                    {{ v.model }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="width: 360px;">
                                <div v-if="vehicle_edit_visible">
                                    <form-input type="text" v-model="v.registration_number"
                                        v-bind:placeholder="$t('pages.checkout.required_field')"
                                        v-bind:label="$t('pages.checkout.registration_number')"
                                        v-bind:errors="v.registration_number_errors"></form-input>
                                </div>
                                <div v-else>
                                    {{ $t('pages.checkout.registration_number') }}:
                                    {{ v.registration_number }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="vehicle_edit_visible">
                    <form-input type="checkbox" v-model="agree_vehicle_term"
                        v-bind:errors="vehicle_errors.agree_vehicle_term">
                        <template v-slot:inline>
                            {{ $t('pages.change.read_term') }}
                            {{ $t('pages.change.term_change') }}
                        </template>
                    </form-input>
                    <div class="n2-padding">
                        <validation-summary v-bind:errors="vehicle_errors"></validation-summary>
                    </div>
                    <p v-if="error_change_vehicle_time_passed" style="color: #ff0000;">
                        {{ $t('pages.change.error_change_time_passed') }}
                    </p>
                    <button style="margin: 20px 0 0 0;" v-on:click="updateVehicles" class="n2-button-1">{{
                        $t('pages.change.update') }}</button>
                </div>
            </div>







            <div style="margin: 20px 0;" class="n2-order-panel">
                <div>
                    <div style="">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <h5>{{ $t('pages.change.passengers') }}</h5>
                            <div v-if="changeable" style="text-align: right">
                                <a class="n2-button-1"
                                    v-bind:href="`/${app_locale}/change-passengers/?email=${entity.contact.email}&booking_number=${entity.booking_number}`">{{
                                        $t('pages.change.edit') }}</a>
                            </div>
                        </div>
                        <h6>{{ $t('pages.change.passengers_desc') }}</h6>
                        <div>
                            <div v-for="(pline) in entity.product_lines" v-bind:key="pline" style="padding: 5px;">
                                <div class="product">
                                    <div class="quanitity-selector">
                                        <span>{{ pline.quantity }}</span>
                                    </div>
                                    <div class="product-name">
                                        <span>{{ pline.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>










            <div v-if="changeable" style="margin: 20px 0;" class="n2-order-panel">
                <h5>{{ $t('pages.change.send_order_email') }}</h5>
                <p>{{ $t('pages.change.send_order_email_desc') }} {{ email_to_send }}</p>
                <div v-if="email_send_success">
                    {{ $t('pages.change.email_send_success') }}
                </div>
                <div v-if="email_send_failed" style="color: red;">
                    {{ $t('pages.change.email_send_failed') }}
                </div>
                <div>
                    <button style="margin: 20px 0 0 0;" v-on:click="sendEmail" class="n2-button-1">{{
                        $t('pages.change.send_email') }}</button>
                </div>
            </div>
        </div>
        <div v-if="responded">
            <div v-if="result_error" class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
            <h4 v-else>{{ $t('pages.change.success') }}</h4>
        </div>
        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { OrderService, EmailService, ShoppingCartService, CheckoutService } from '../../services'

import AppLoader from '../../components/shared/loader.vue';
import FormInput from '../../components/shared/form-input.vue';
import ValidationSummary from "../../components/shared/validation-summary.vue"
import FieldError from '../../components/shared/field-error.vue';
import country_list from '../../data/country-list'
import AppAutocomplete from '../../components/shared/autocomplete.vue'
import PhoneNumberField from './phone-number-field.vue'

export default {
    components: {
        AppLoader, FormInput, ValidationSummary, FieldError, AppAutocomplete, PhoneNumberField
    },
    props: ['entity'],
    data: function () {
        return {
            vehicle_errors: {},
            contact_errors: {},
            changeable: false,
            contact_edit_visible: false,
            vehicle_edit_visible: false,
            passenger_edit_visible: false,
            agree_contact_term: false,
            agree_vehicle_term: false,
            responded: false,
            loading: false,
            result_error: '',
            email_to_send: '',
            email_send_success: false,
            email_send_failed: false,
            error_change_contact_time_passed: false,
            error_change_vehicle_time_passed: false
        };
    },
    watch: {
        'entity': function (pre, after) {
            if (pre && after && pre.booking_number != after.booking_number) {
                this.responded = false;
            }
            if (after) {
                this.email_to_send = this.entity.contact.email;
                this.calulateStatus()
            }
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ]),
        ...mapGetters('shopping_cart_store', [
            'shopping_cart'
        ]),
        countries: function () {
            if (this.app_locale == 'no') {
                return country_list.no
            }
            else {
                return country_list.en
            }
        }
    },
    created: function () {
        this.checkoutService = new CheckoutService()
        this.orderService = new OrderService()
        this.emailService = new EmailService()
        this.shoppingCartService = new ShoppingCartService()
    },
    mounted: function () {
        this.calulateStatus()
        if (this.entity && this.entity.contact) {
            this.email_to_send = this.entity.contact.email
        }
    },
    methods: {
        getProductName: function (product_id) {
            return this.entity.product_lines.find(p => p.product_id == product_id).title;
        },
        getCountryName: function (code) {
            return this.countries.find(c => c.code == code).name
        },

        calulateStatus: function () {
            this.changeable = false;
            if (this.entity && this.entity.status != 'cancelled' && this.entity.legs) {
                let steps = this.entity.legs.reduce((acc, cur) => {
                    return [...acc, ...cur.steps]
                }, [])
                if (steps.some(s => s.transit && new Date(s.transit.depart_at) > new Date())) {
                    this.changeable = true;
                }
            }
        },

        validateContact: function () {
            this.contact_errors = {}
            let patternPhone = new RegExp(/^([+]{0,1})((?:\s*\d){8,})$/)
            if (!patternPhone.test(this.entity.contact.phone_number)) {
                this.contact_errors['phone_number'] = [this.$t('pages.checkout.error_phone_number')]
            }
            let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!patternEmail.test(this.entity.contact.email)) {
                this.contact_errors['email'] = [this.$t('pages.checkout.error_email')]
            }
            if (!this.entity.contact.given_name) {
                this.contact_errors['given_name'] = [this.$t('pages.checkout.error_given_name')]
            }
            if (!this.entity.contact.family_name) {
                this.contact_errors['family_name'] = [this.$t('pages.checkout.error_family_name')]
            }
            if (!this.agree_contact_term) {
                this.contact_errors['agree_contact_term'] = [this.$t('pages.change.error_agree_term')]
            }
            switch (this.entity.template) {
                case 'online_payment':
                    break;
                default:
                    if (!this.entity.contact.address.address_line_1) {
                        this.contact_errors['address_line_1'] = [this.$t('pages.checkout.error_address_line_1')]
                    }
                    if (!this.entity.contact.address.postal_code) {
                        this.contact_errors['postal_code'] = [this.$t('pages.checkout.error_postal_code')]
                    }
                    if (!this.entity.contact.address.locality) {
                        this.contact_errors['locality'] = [this.$t('pages.checkout.error_locality')]
                    }
                    if (!this.entity.contact.address.country_code) {
                        this.contact_errors['country_code'] = [this.$t('pages.checkout.error_country_code')]
                    }
            }
            if (Object.keys(this.contact_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        updateContact: async function () {
            if (this.validateContact()) {

                try {
                    this.error_change_contact_time_passed = false
                    this.loading = true;
                    await this.orderService.updateContact(this.entity.id, this.entity.contact, this.entity.token);
                    this.contact_edit_visible = false
                    this.email_to_send = this.entity.contact.email
                }
                catch (e) {
                    if (e.data) {
                        if (e.data.error_code == 'change_time_passed') {
                            this.error_change_contact_time_passed = true
                        }
                        else if (e.data.error_code == 'model_error') {
                            if (e.data.errors.phone_number) {
                                this.contact_errors['phone_number'] = [this.$t('pages.checkout.error_phone_number')]
                            }
                        }
                    }
                }
                finally {
                    this.loading = false;
                }
            }
        },
        validateVehicles: function () {
            this.vehicle_errors = {}
            if (!this.agree_vehicle_term) {
                this.vehicle_errors['agree_vehicle_term'] = [this.$t('pages.change.error_agree_term')]
            }
            this.entity.vehicles.forEach(v => {
                v.model_errors = null;

                v.registration_number_errors = null;
                var result = true
                if (!/(.*[a-z]){3}/i.test(v.model)) {
                    result = false
                }
                if (!v.model || v.model.length < 4) {
                    result = false
                }
                if (!result) {
                    v.model_errors = [this.$t('pages.checkout.error_vehicle_model')]
                }

                var numberResult = true
                if (v.registration_number.length < 2) {
                    numberResult = false
                }
                if (!numberResult) {
                    v.registration_number_errors = [this.$t('pages.checkout.error_vehicle_registration_number')]
                }
                console.log(result, numberResult)
                if (!result || !numberResult) {
                    this.vehicle_errors['vehicle_info'] = [this.$t('pages.checkout.error_vehicle_info')]
                }
            })
            //////////////////
            if (Object.keys(this.vehicle_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        updateVehicles: async function () {
            if (this.validateVehicles()) {
                try {
                    this.error_change_vehicle_time_passed = false
                    this.loading = true;
                    await this.orderService.updateVehicles(this.entity.id, this.entity.vehicles, this.entity.token);
                    this.vehicle_edit_visible = false
                }
                catch (e) {
                    if (e.data && e.data.error_code == 'change_time_passed')
                        this.error_change_vehicle_time_passed = true
                }
                finally {
                    this.loading = false;
                }
            }
        },
        sendEmail: async function () {
            this.email_send_success = false;
            this.email_send_failed = false;
            try {
                this.loading = true;
                await this.emailService.sendOrderChangeEmail(this.entity.id, this.entity.token);
                this.email_send_success = true;
            }
            catch {
                this.email_send_failed = true;
            }
            finally {
                this.loading = false;
            }
        },
    }
}
</script>
<style lang="sass">
</style>
